import { Direction } from 'types'

export const wordBankSelectInitialState = {
  direction: Direction.Right
}

export type WordBankSelectState = typeof wordBankSelectInitialState
